export default __webpack_public_path__ + "static/media/image01.aa3ce28a.jpg";